import { jwtDecode } from "jwt-decode";
import { LOGIN_SUCCESS, LOGOUT } from "../actions";

const token = localStorage.getItem("accessToken");

const initialState = {
  token: token ? token : null,
  isAuthenticated: token ? true : false,
  user: token ? jwtDecode(token) : null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.token,
        refreshToken: action.payload.refreshToken,
        isAuthenticated: true,
        user: jwtDecode(action.payload.token),
      };
    case LOGOUT:
      return {
        ...state,
        token: null,
        refreshToken: null,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
